export default "__VITE_ASSET__de7780ac__"